import React from 'react';
import { Routes, Route, Navigate, useNavigate, useParams } from 'react-router-dom';
import CharacterCreator from './CharacterCreator';
import CharacterList from './CharacterList';
import CharacterProgression from './CharacterProgression';
import CharacterEquipment from './CharacterEquipment';

const CharacterProgressionRoute: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const characterId = Number(id);

  if (!id || Number.isNaN(characterId)) {
    return <Navigate to="/characters" replace />;
  }

  return <CharacterProgression characterId={characterId} onBack={() => navigate('/characters')} />;
};

const CharacterEquipmentRoute: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const characterId = Number(id);

  if (!id || Number.isNaN(characterId)) {
    return <Navigate to="/characters" replace />;
  }

  return <CharacterEquipment characterId={characterId} onBack={() => navigate('/characters')} />;
};

const Characters: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="characters-page">
      <Routes>
        <Route
          index
          element={
            <CharacterList
              onCreateCharacter={() => navigate('/characters/create')}
              onViewProgression={(character) => navigate(`/characters/${character.id}/progression`)}
              onManageEquipment={(character) => navigate(`/characters/${character.id}/equipment`)}
            />
          }
        />
        <Route
          path="create"
          element={
            <CharacterCreator
              onCharacterCreated={() => navigate('/characters')}
              onCancel={() => navigate('/characters')}
            />
          }
        />
        <Route path=":id/progression" element={<CharacterProgressionRoute />} />
        <Route path=":id/equipment" element={<CharacterEquipmentRoute />} />
        <Route path="*" element={<Navigate to="/characters" replace />} />
      </Routes>
    </div>
  );
};

export default Characters;
